import { FileTypeEnum } from 'remote/global';
import { isProd } from './helpers';

declare global {
  interface Window {
    gtag: any;
  }
}

export const isGTMInitialized = isProd && 'gtag' in window && typeof window?.gtag !== 'undefined';

const isGTMTrackingEnabled = (cb: Function) => {
  if (isGTMInitialized) cb();
};

export const track = {
  partner_login: () => {
    isGTMTrackingEnabled(() => {
      window.gtag('event', 'partner_login', { event_category: 'authentication' });
    });
  },
  partner_logout: () => {
    isGTMTrackingEnabled(() => {
      window.gtag('event', 'partner_logout', { event_category: 'authentication' });
    });
  },
  partner_menu_click: (item: string) => {
    isGTMTrackingEnabled(() => {
      window.gtag('event', 'menu_item_click', {
        event_category: 'navigation',
        event_label: item,
      });
    });
  },
  partner_file_upload: (fileType: FileTypeEnum) => {
    isGTMTrackingEnabled(() => {
      window.gtag('event', 'partner_file_upload', {
        event_category: 'user_action',
        event_label: fileType,
      });
    });
  },
  partner_button_click: (label: string) => {
    isGTMTrackingEnabled(() => {
      window.gtag('event', 'partner_button_click', {
        event_category: 'user_action',
        event_label: label,
      });
    });
  },
};
